import { View, VStack, Text, Box } from "@gluestack-ui/themed";
import { useWindowDimensions } from "react-native";
import Svg, { Ellipse } from "react-native-svg";

const FACE_WIDTH_RATIO = 0.36;
const MOBILE_FACE_WIDTH_RATIO = 0.64;
const FACE_HEIGHT_RATIO = 1.55;
const FACE_MAX_WIDTH = 380;
const FACE_MIN_WIDTH = 240;
const FACE_MAX_HEIGHT_RATIO = 0.66;
const FACE_TOP_RATIO = 0.15;
const CAMERA_CONTROLS_HEIGHT = 136;
const INSTRUCTION_BOTTOM = 120;

export const SelfieMask = () => {
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();
  const isCompact = screenWidth < 768;
  const widthRatio = isCompact ? MOBILE_FACE_WIDTH_RATIO : FACE_WIDTH_RATIO;
  const maxAvailableHeight = Math.max(
    screenHeight -
      CAMERA_CONTROLS_HEIGHT -
      INSTRUCTION_BOTTOM -
      screenHeight * FACE_TOP_RATIO,
    FACE_MIN_WIDTH
  );
  const maskWidth = Math.min(
    Math.max(screenWidth * widthRatio, isCompact ? 220 : FACE_MIN_WIDTH),
    isCompact ? screenWidth * 0.82 : FACE_MAX_WIDTH,
    maxAvailableHeight / FACE_HEIGHT_RATIO
  );
  const maskHeight = Math.min(
    maskWidth * FACE_HEIGHT_RATIO,
    screenHeight * FACE_MAX_HEIGHT_RATIO,
    maxAvailableHeight
  );
  const maskLeft = (screenWidth - maskWidth) / 2;
  const maskTop = Math.max(screenHeight * FACE_TOP_RATIO, 40);
  const maskCenterX = maskLeft + maskWidth / 2;
  const maskCenterY = maskTop + maskHeight / 2;

  return (
    <View
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={10}
      pointerEvents="none"
    >
      {/* Full dark overlay */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="rgba(0, 0, 0, 0.6)"
      />

      {/* Circular/oval border guide */}
      <Svg
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 11
        }}
        width={screenWidth}
        height={screenHeight}
      >
        <Ellipse
          cx={maskCenterX}
          cy={maskCenterY}
          rx={maskWidth / 2}
          ry={maskHeight / 2}
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth={3}
          fill="none"
        />
      </Svg>

      {/* Instructions */}
      <VStack
        position="absolute"
        bottom={120}
        left={0}
        right={0}
        alignItems="center"
        px="$4"
      >
        <Text
          fontSize="$md"
          fontWeight={600}
          color="$white"
          textAlign="center"
          style={{
            textShadowColor: "rgba(0, 0, 0, 0.75)",
            textShadowOffset: { width: 0, height: 1 },
            textShadowRadius: 3
          }}
        >
          Posicione seu rosto dentro do círculo
        </Text>
        <Text
          fontSize="$sm"
          color="$white"
          textAlign="center"
          mt="$1"
          style={{
            textShadowColor: "rgba(0, 0, 0, 0.75)",
            textShadowOffset: { width: 0, height: 1 },
            textShadowRadius: 3
          }}
        >
          Mantenha os olhos abertos e olhe diretamente para a câmera
        </Text>
      </VStack>
    </View>
  );
};
